export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8457.c939bb9b.jpg";